<template>
    <div class="table-responsive" id="applicants">

        <table class="table">
            <thead>
                <tr>
                    <th><label class="checkmark-box serial" id="checkAll" tabindex="0"><input @click="toggleSelectAll" v-model="selectAllCheckbox" class="checkAll" type="checkbox"> <span class="checkmark"></span></label></th>
                    <th>Name</th>
                    <th>
                        <div class="dropdown">
                            <a aria-expanded="false" aria-haspopup="true" class="th-design dropdown-toggle" :class="{ 'highlight-dropdown' : isSelectedDateFilterText }" data-toggle="dropdown" href="#" id="dropdownMenuLink" role="button"><span class="defaultvalue">{{selectedDateFilterText}}</span> <span class="value">{{selectedDateFilterText}}</span></a>
                            <ul class="dropdown-menu">
                                <li><label class="checkmark-box" tabindex="0">7 days<input @click="uncheckDateFilter( '7 days' )" v-model="dateFilter" name="date" value="7 days" type="radio"> <span class="checkmark"></span></label></li>
                                <li><label class="checkmark-box" tabindex="0">1 month<input @click="uncheckDateFilter( '1 month' )" v-model="dateFilter" name="date" value="1 month" type="radio"> <span class="checkmark"></span></label></li>
                                <li><label class="checkmark-box" tabindex="0">3 months<input @click="uncheckDateFilter( '3 months' )" v-model="dateFilter" name="date" value="3 months" type="radio"> <span class="checkmark"></span></label></li>
                                <li><label class="checkmark-box" tabindex="0">6 months<input @click="uncheckDateFilter( '6 months' )" v-model="dateFilter" name="date" value="6 months" type="radio"> <span class="checkmark"></span></label></li>
                                <li><label class="checkmark-box" tabindex="0">All time<input @click="uncheckDateFilter( 'All time' )" v-model="dateFilter" name="date" value="All time" type="radio"> <span class="checkmark"></span></label></li>
                            </ul>
                        </div>
                    </th>
                    <th>
                        <div class="dropdown">
                            <a aria-expanded="false" aria-haspopup="true" class="th-design status dropdown-toggle" :class="{ 'highlight-dropdown' : isSelectedAppStatusFilterText }" data-toggle="dropdown" href="#" id="dropdownMenuLink" role="button"><span class="defaultvalue">{{selectedAppStatusFilterText}}</span> <span class="value">{{selectedAppStatusFilterText}}</span></a>
                            <ul class="dropdown-menu" style="position: absolute; will-change: transform; top: 0px; left: 0px; transform: translate3d(0px, 39px, 0px);">
                                <li><label class="checkmark-box" tabindex="0">Approved<input v-model="appStatusFilterApproved" name="appstatus" id="Approved" type="checkbox"> <span class="checkmark"></span></label></li>
                                <li><label class="checkmark-box" tabindex="0">Lead<input v-model="appStatusFilterLead" name="appstatus" type="checkbox"> <span class="checkmark"></span></label></li>
                                <li><label class="checkmark-box" tabindex="0">Needs Work<input v-model="appStatusFilterNeedsWork" name="appstatus" type="checkbox"> <span class="checkmark"></span></label></li>
                                <li><label class="checkmark-box" tabindex="0">ServiceDrive<input v-model="appStatusFilterServiceDrive" name="appstatus" type="checkbox"> <span class="checkmark"></span></label></li>
                            </ul>
                        </div>
                    </th>
                    <th>
                        <div class="dropdown">
                            <a aria-expanded="false" aria-haspopup="true" class="th-design status dropdown-toggle" :class="{ 'highlight-dropdown' : isSelectedAssignedFilterText }" data-toggle="dropdown" href="#" id="dropdownMenuLink" role="button"><span class="defaultvalue">{{selectedAssignedFilterText}}</span><span class="value">{{selectedAssignedFilterText}}</span></a>
                            <ul class="dropdown-menu" style="position: absolute; will-change: transform; top: 0px; left: 0px; transform: translate3d(0px, 39px, 0px);">
                                <li v-for="(assignedListItem) in assignedListItems" :key="assignedListItem"><label class="checkmark-box" tabindex="0">{{assignedListItem.leadGroupName}}<input @click="uncheckAssignedFilter( assignedListItem )" v-model="assignedFilter" name="date" :value="assignedListItem" type="radio"> <span class="checkmark"></span></label></li>
                            </ul>
                        </div>
                    </th>
                    <th>
                        <div class="dropdown">
                            <a aria-expanded="false" aria-haspopup="true" class="th-design health" :class="{ 'highlight-dropdown' : isCreditScoreFilter }" data-toggle="dropdown" href="#" id="dropdownMenuLink" role="button"><img alt="image" class="img-fluid" :src="selectedCreditDialImage"></a>
                            <ul class="dropdown-menu" style="position: absolute; will-change: transform; top: 0px; left: 0px; transform: translate3d(0px, 39px, 0px);">
                                <li><label class="checkmark-box" tabindex="0"><strong class="poor">Poor</strong><span class="range">300-579 </span><input @click="uncheckCreditScoreFilter( 'Poor' )" v-model="creditScoreFilter" name="date" value="Poor" type="radio"> <span class="checkmark"></span></label></li>
                                <li><label class="checkmark-box" tabindex="0"><strong class="fair">Fair</strong><span class="range">580-669 </span><input @click="uncheckCreditScoreFilter( 'Fair' )" v-model="creditScoreFilter" name="date" value="Fair" type="radio"> <span class="checkmark"></span></label></li>
                                <li><label class="checkmark-box" tabindex="0"><strong class="good">Good</strong><span class="range">670-739 </span><input @click="uncheckCreditScoreFilter( 'Good' )" v-model="creditScoreFilter" name="date" value="Good" type="radio"> <span class="checkmark"></span></label></li>
                                <li><label class="checkmark-box" tabindex="0"><strong class="verygood">Very Good</strong><span class="range">740-799 </span><input @click="uncheckCreditScoreFilter( 'Very Good' )" v-model="creditScoreFilter" name="date" value="Very Good" type="radio"> <span class="checkmark"></span></label></li>
                                <li><label class="checkmark-box" tabindex="0"><strong class="excellent">Excellent</strong><span class="range">800-850 </span><input @click="uncheckCreditScoreFilter( 'Excellent' )" v-model="creditScoreFilter" name="date" value="Excellent" type="radio"> <span class="checkmark"></span></label></li>
                            </ul>
                        </div>
                    </th>
                    <th><img alt="image" class="img-fluid" src="../assets/opportunity-not.svg" width="15"></th>
                </tr>
            </thead>
            <tbody>

                <!--<applicant-grid-row v-for="(applicantRow) in applicantsList" :key="applicantRow.applicantId"
                        v-bind:applicantRow="applicantRow"
                        v-bind:searchTerms="searchTerms"
                        v-bind:dateFilter="dateFilter"
                        v-bind:appStatusFilterApproved="appStatusFilterApproved"
                        v-bind:appStatusFilterLead="appStatusFilterLead"
                        v-bind:appStatusFilterNeedsWork="appStatusFilterNeedsWork"
                        v-bind:appStatusFilterServiceDrive="appStatusFilterServiceDrive"
                        v-bind:assignedFilter="assignedFilter"
                        v-bind:creditScoreFilter="creditScoreFilter"
                        v-bind:showArchived="showArchived"
                        @add-to-selected-applicants="addToSelectedApplicants"
                        @remove-from-selected-applicants="removeFromSelectedApplicants"
                        @remove-all-selected-applicants="removeAllSelectedApplicants"
                        :ref="addApplicantRowRef"/>
    -->

                <tr>
                    <td><label class="checkmark-box serial"><input type="checkbox"> <span class="checkmark"></span></label></td>
                    <td style="cursor: pointer;">
                        <div class="client-name">

                            <div>LA</div>

                        </div>
                    </td>
                    <td style="cursor: pointer;">5/25/2021</td>
                    <td style="cursor: pointer;"><span class="bg-btn">Needs Work</span></td>
                    <td style="cursor: pointer;"><span class="bg-btn">Walk-in</span></td>
                    <td>
                        <p class="good">712</p>
                    </td>
                    <td></td>
                    <td>
                        <div><img alt="image" class="img-fluid" src="../assets/opportunity-hot.svg"></div>
                    </td>
                </tr>

                <tr class="selected">
                    <td><label class="checkmark-box serial"><input type="checkbox" checked="checked"> <span class="checkmark"></span></label></td>
                    <td style="cursor: pointer;">
                        <div class="client-name">

                            <div>ES</div>

                        </div>
                    </td>
                    <td style="cursor: pointer;">5/21/2021</td>
                    <td style="cursor: pointer;"><span class="bg-btn">Needs Work</span></td>
                    <td data-v-step="2" style="cursor: pointer;"><span class="bg-btn">Internet Sales</span></td>
                    <td>
                        <p>509</p>
                    </td>
                    <td></td>
                    <td>
                        <div><img alt="image" class="img-fluid" src="../assets/opportunity-not.svg"></div>
                    </td>
                </tr>

                <tr>
                    <td><label class="checkmark-box serial"><input type="checkbox"> <span class="checkmark"></span></label></td>
                    <td style="cursor: pointer;">
                        <div class="client-name">

                            <div>NO</div>

                        </div>
                    </td>
                    <td style="cursor: pointer;">4/30/2021</td>
                    <td style="cursor: pointer;"><span class="bg-btn">Lead</span></td>
                    <td style="cursor: pointer;"><span class="bg-btn">Vehicle Sales</span></td>
                    <td>
                        <p>---</p>
                    </td>
                    <td></td>
                    <td>
                        <div><img alt="image" class="img-fluid" src="../assets/opportunity-not.svg"></div>
                    </td>
                </tr>

                <tr>
                    <td><label class="checkmark-box serial"><input type="checkbox"> <span class="checkmark"></span></label></td>
                    <td style="cursor: pointer;">
                        <div class="client-name">

                            <div>MB</div>

                        </div>
                    </td>
                    <td style="cursor: pointer;">4/28/2021</td>
                    <td style="cursor: pointer;"><span class="bg-btn">Needs Work</span></td>
                    <td style="cursor: pointer;"><span class="bg-btn">Walk-in</span></td>
                    <td>
                        <p class="fair">640</p>
                    </td>
                    <td></td>
                    <td>
                        <div><img alt="image" class="img-fluid" src="../assets/opportunity-hot.svg"></div>
                    </td>
                </tr>

                <tr>
                    <td><label class="checkmark-box serial"><input type="checkbox"> <span class="checkmark"></span></label></td>
                    <td style="cursor: pointer;">
                        <div class="client-name">

                            <div>AK</div>

                        </div>
                    </td>
                    <td style="cursor: pointer;">4/24/2021</td>
                    <td style="cursor: pointer;"><span class="bg-btn">Lead</span></td>
                    <td style="cursor: pointer;"><span class="bg-btn">Internet Sales</span></td>
                    <td>
                        <p>---</p>
                    </td>
                    <td></td>
                    <td>
                        <div><img alt="image" class="img-fluid" src="../assets/opportunity-not.svg"></div>
                    </td>
                </tr>

            </tbody>
        </table>


    </div>
</template>

<script>
    //import ApplicantGridRow from './ApplicantGridRow.vue';

    export default {
        name: "ApplicantGrid",
        props: {
            searchTerms: String,
            assignedListItems: Array,
            showArchived: Boolean
        },
        watch: {
            searchTerms: {
                handler: function () {
                    //this.updateNumberOfVisibleRows();
                }
            },
            showArchived: {
                handler: function () {
                    //this.updateNumberOfVisibleRows();
                }
            }
        },
        computed: {
            isSelectedDateFilterText() {
                if (this.selectedDateFilterText != "Date") {
                    return true;
                } else {
                    return false;
                }
            },
            isSelectedAppStatusFilterText() {
                if (this.selectedAppStatusFilterText != "App Status") {
                    return true;
                } else {
                    return false;
                }
            },
            isSelectedAssignedFilterText() {
                if (this.selectedAssignedFilterText != "Assigned") {
                    return true;
                } else {
                    return false;
                }
            },
            isCreditScoreFilter() {
                if (this.creditScoreFilter != "") {
                    return true;
                } else {
                    return false;
                }
            },
            selectedDateFilterText() {
                if (this.dateFilter == "") {
                    return "Date";
                } else {
                    return this.dateFilter;
                }
            },
            selectedAppStatusFilterText() {
                if (this.appStatusFilterApproved) {
                    if (this.appStatusFilterLead || this.appStatusFilterNeedsWork || this.appStatusFilterServiceDrive) {
                        return "Multiple";
                    } else {
                        return "Approved";
                    }
                } else if (this.appStatusFilterLead) {
                    if (this.appStatusFilterApproved || this.appStatusFilterNeedsWork || this.appStatusFilterServiceDrive) {
                        return "Multiple";
                    } else {
                        return "Lead";
                    }
                } else if (this.appStatusFilterNeedsWork) {
                    if (this.appStatusFilterApproved || this.appStatusFilterLead || this.appStatusFilterServiceDrive) {
                        return "Multiple";
                    } else {
                        return "Needs Work";
                    }
                } else if (this.appStatusFilterServiceDrive) {
                    if (this.appStatusFilterApproved || this.appStatusFilterLead || this.appStatusFilterNeedsWork) {
                        return "Multiple";
                    } else {
                        return "ServiceDrive";
                    }
                } else {
                    return "App Status";
                }
            },
            selectedAssignedFilterText() {
                if (this.assignedFilter == null || this.assignedFilter == "") {
                    return "Assigned";
                } else {
                    return this.assignedFilter.leadGroupName;
                }
            },
            selectedCreditDialImage() {
                if (this.creditScoreFilter == "") {
                    return require('../assets/credit-dial.svg');
                } else {
                    return require('../assets/credit-dial-selected.svg');
                }
            }
        },
        data() {
            return {
                dateFilter: "",
                appStatusFilter: "",
                appStatusFilterApproved: false,
                appStatusFilterLead: false,
                appStatusFilterNeedsWork: false,
                appStatusFilterServiceDrive: false,
                assignedFilter: null,
                creditScoreFilter: "",
                selectAllCheckbox: false,
                selectedApplicants: [],
                numberOfVisibleRows: 0,
                applicantRowRefs: [],
                applicantsList: [
                    {
                        applicantId: 1,
                        initials: "LA",
                        firstName: "Liam",
                        lastName: "Anderson",
                        applicationDate: "5/25/2021",
                        applicationStatus: "Needs Work",
                        assignedStatus: "Vehicle Sales",
                        creditScore: "712",
                        creditScoreClass: "good",
                        hasOpportunityAlert: true,
                        opportunityAlert: "Pending Payoff LevelCredit Result",
                        rowSelected: false
                    },
                    {
                        applicantId: 2,
                        initials: "ES",
                        firstName: "Ester",
                        lastName: "Pzykk",
                        applicationDate: "05/25/21",
                        applicationStatus: "Needs Work",
                        assignedStatus: "Internet Sales",
                        creditScore: "509",
                        creditScoreClass: "fair",
                        hasOpportunityAlert: false,
                        opportunityAlert: "",
                        rowSelected: true
                    },
                    {
                        applicantId: 3,
                        initials: "NO",
                        firstName: "",
                        lastName: "",
                        applicationDate: "4/30/21",
                        applicationStatus: "Lead",
                        assignedStatus: "Vehicle Sales",
                        creditScore: "",
                        creditScoreClass: "",
                        hasOpportunityAlert: false,
                        opportunityAlert: ""
                    },
                    {
                        applicantId: 4,
                        initials: "MB",
                        firstName: "",
                        lastName: "",
                        applicationDate: "4/28/21",
                        applicationStatus: "Needs Work",
                        assignedStatus: "Internet Sales",
                        creditScore: "640",
                        creditScoreClass: "Fair",
                        hasOpportunityAlert: false,
                        opportunityAlert: ""
                    },
                    {
                        applicantId: 5,
                        initials: "AK",
                        firstName: "",
                        lastName: "",
                        applicationDate: "4/24/21",
                        applicationStatus: "Lead",
                        assignedStatus: "Internet Sales",
                        creditScore: "",
                        creditScoreClass: "",
                        hasOpportunityAlert: false,
                        opportunityAlert: ""
                    }
                ],
                isLoading: false
            }
        },
        beforeUpdate() {
            this.applicantRowRefs = []
        },
        updated() {
            this.updateNumberOfVisibleRows();
        },
        methods: {
            addApplicantRowRef(el) {
                if (el) {
                    this.applicantRowRefs.push(el);
                }
            },
            updateNumberOfVisibleRows() {
                const countOfRows = this.applicantRowRefs.reduce((acc, cur) => cur.showRow === true ? ++acc : acc, 0);
                //console.log(countOfRows);
                this.numberOfVisibleRows = countOfRows;
            },
            toggleSelectAll() {
                var that = this;
                this.applicantsList.forEach(function (x) {
                    //x.rowSelected = !that.selectAllCheckbox;
                    if (!that.selectAllCheckbox) {
                        that.addToSelectedApplicants(x.applicantId);
                    } else {
                        that.removeFromSelectedApplicants(x.applicantId);
                    }
                });
            },
            uncheckDateFilter: function (val) {
                if (val === this.dateFilter) {
                    this.dateFilter = false
                } else {
                    this.dateFilter = val
                }
            },
            uncheckAppStatusFilter: function (val) {
                if (val === this.appStatusFilter) {
                    this.appStatusFilter = false
                } else {
                    this.appStatusFilter = val
                }
            },
            uncheckAssignedFilter: function (val) {
                if (val === this.assignedFilter) {
                    this.assignedFilter = null
                } else {
                    this.assignedFilter = val
                }
            },
            uncheckCreditScoreFilter: function (val) {
                if (val === this.creditScoreFilter) {
                    this.creditScoreFilter = false
                } else {
                    this.creditScoreFilter = val
                }
            },
            addToSelectedApplicants(applicantId) {
                this.selectedApplicants.push(applicantId);
                this.findSelectedApplicantInApplicantListByApplicantId(applicantId).rowSelected = true;
                this.$emit('scroll-to-applicant-detail');
                this.$emit('refresh-selected-applicants', this.getSelectedApplicantsFromList());
            },
            removeFromSelectedApplicants(applicantId) {
                this.findSelectedApplicantInApplicantListByApplicantId(applicantId).rowSelected = false;
                const index = this.selectedApplicants.indexOf(applicantId);
                if (index > -1) {
                    this.selectedApplicants.splice(index, 1);
                }
                this.$emit('refresh-selected-applicants', this.getSelectedApplicantsFromList());
            },
            removeAllSelectedApplicants() {
                this.applicantsList.forEach(function (x) {
                    x.rowSelected = false;
                });
                this.selectedApplicants = [];
                this.selectAllCheckbox = false;
                this.$emit('refresh-selected-applicants', []);
                this.scrollToTopOfPage();
            },
            selectASingleApplicant(applicantId) {
                this.removeAllSelectedApplicants();
                this.addToSelectedApplicants(applicantId);
                this.$emit('scroll-to-applicant-detail');
            },
            getSelectedApplicantsFromList() {
                return this.applicantsList.filter(item => this.selectedApplicants.indexOf(item.applicantId) !== -1);
            },
            findSelectedApplicantInApplicantListByApplicantId(applicantId) {
                return this.applicantsList.find(x => x.applicantId == applicantId);
            },
            findSelectedApplicantIndexInApplicantListByApplicantId(applicantId) {
                return this.applicantsList.findIndex(x => x.applicantId == applicantId);
            },
            scrollToTopOfPage() {
                if ('scrollRestoration' in history) {
                    history.scrollRestoration = 'manual';
                }
                window.scrollTo(0, 0);
            }
        },
        mounted() {
            
        },
        components: {
            //'applicant-grid-row': ApplicantGridRow
        }
    }
</script>

<style type="text/css" scoped>
    @import '../css/clientstyle.css';
    @import '../css/clientstyle2.css';
    @import '../css/clientresponsive.css';

    .highlight-dropdown {
        background-color: #4444ff;
        color: white !important;
    }
</style>